<template>
  <div
    class="app-error-messages d-flex justify-center"
    data-html2canvas-ignore
  >
    <div>
      <v-alert
        v-for="(message, index) in messages"
        :key="index + '-message'"
        class="mb-2 elevation-4"
        :type="message.type.toLowerCase()"
        closable
        color="white"
        :icon="false"
        rounded="lg"
      >
        <v-icon
          v-if="['error', 'warning'].includes(message.type)"
          outlined
          color="primary"
          class="mr-2"
        >
          warning
        </v-icon>
        {{ message.message }}
      </v-alert>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue"
import {storeToRefs} from "pinia"
import {useAppStore} from "@/stores/app"
import {useLayout} from "vuetify"

const {mainRect} = useLayout()

const topOffset = computed(() => {
  return `${mainRect.value.top}px`
})

const app = useAppStore()
const {messages} = storeToRefs(app)
</script>

<style scoped lang="scss">
.app-error-messages {
  position: fixed;
  width: 100%;
  top: calc(v-bind(topOffset) + 50px);
  z-index: 99000;
  left: calc(100% / 2);
  transform: translate(-50%, 0);

  .v-alert {
    width: 100%;
    max-width: 600px;
    margin: 0 20px;
  }
}
</style>
